import { DoubleState, useDoubleStore } from '@/context/DoubleProvider'
import { useSystem } from '@/context/SystemProvider'
import { Box, Flex, Progress, Text } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import Trapezoid from '@/public/assets/images/double/trapezoid.svg'
import { useTranslation } from 'next-i18next/pages'

export const DoubleCounter = () => {
  const getCurrentDateTime = useSystem((state) => state.getCurrentDateTime)
  const [time, setTime] = useState(getCurrentDateTime().getTime())
  const drawTimestamp = useDoubleStore((x) => x.drawTimestamp)
  const state = useDoubleStore((x) => x.state)

  const refState = useRef(state)

  useEffect(() => {
    refState.current = state
  }, [state])

  useEffect(() => {
    const interval = setInterval(() => {
      if (refState.current === DoubleState.PROCESSING || refState.current === DoubleState.INIT) {
        setTime(getCurrentDateTime().getTime())
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  const countdown = Math.max(Math.floor((drawTimestamp - time) / 1000), 0)
  const ROUND_DURATION = 15

  return (
    <Box w={'full'} pos={'absolute'} bottom={0} right={0} left={0}>
      <Flex alignItems={'center'} justifyContent={'center'}>
        <Trapezoid />
        <Box p={1.5} textAlign={'center'} fontWeight={700} pos={'absolute'}>
          <Counter countdown={countdown} state={state} />
        </Box>
      </Flex>
      <Progress
        bg="#60659E"
        size="sm"
        h={1.5}
        transition={'.2s'}
        value={state === DoubleState.INIT ? 100 : (countdown / ROUND_DURATION) * 100}
        sx={{
          '& > div': {
            background: 'linear-gradient(291.97deg, #8E83FB 31.11%, #5D52EE 97.01%);',
            rounded: 'lg',
            transition: '.2s',
          },
        }}
      />
    </Box>
  )
}

const Counter = ({ countdown, state }: { countdown: number; state: DoubleState | null }) => {
  const { t } = useTranslation()
  if (state === DoubleState.INIT || !state) {
    return <Text fontWeight={700}>{t('common.collecting-bets')}</Text>
  }

  if (countdown === 0) {
    return <Text fontWeight={700}>{t('common.rolling')}</Text>
  }

  return (
    <>
      <Text color={'ninja.100'} fontSize={'xs'}>
        {t('double.rolling-in')}
      </Text>
      <Text fontSize={'xl'}>{countdown} sec.</Text>
    </>
  )
}
